function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.1832 18.7133H19.8823L19.4213 18.2687C21.035 16.3915 22.0065 13.9545 22.0065 11.3034C22.0065 5.39186 17.2148 0.600098 11.3033 0.600098C5.39177 0.600098 0.600006 5.39186 0.600006 11.3034C0.600006 17.2148 5.39177 22.0066 11.3033 22.0066C13.9544 22.0066 16.3914 21.0351 18.2686 19.4214L18.7132 19.8824V21.1833L26.9465 29.4001L29.4 26.9466L21.1832 18.7133ZM11.3033 18.7133C7.20309 18.7133 3.89332 15.4035 3.89332 11.3034C3.89332 7.20318 7.20309 3.89341 11.3033 3.89341C15.4034 3.89341 18.7132 7.20318 18.7132 11.3034C18.7132 15.4035 15.4034 18.7133 11.3033 18.7133Z",
  fill: "white"
});

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5a1ae4dd.svg";
export { ForwardRef as ReactComponent };